<template>
    <div class="container">
        <section class="section">
            <div class="u-mb-3">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Settings</div>
                    </div>
                </div>
            </div>
            <div class="section__content">
                <ul class="nav nav-tabs d-none d-lg-flex justify-content-start nav-tabs" role="tablist">
                    <li class="nav-item nav-item--active">
                        <button @click="$router.push('/settings/profile')" class="btn btn--tertiary btn--block nav-link nav-link--active rounded-0 m-auto"
                                type="button" data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="true">
                            <div class="nav-link__tab"><span class="nav-link__label">Profile</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/preferences')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Preferences</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/verification')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Verification</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/security')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Security</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/payment-methods')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Payment methods</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/apps')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Apps</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/limits')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Limits</span></div>
                        </button>
                    </li>
                </ul>
                <div class="dropdown d-block d-lg-none tabs-dropdown">
                    <div class="dropdown-toggle d-block w-100 py-1" id="settings-toggle" aria-haspopup="true"
                         aria-expanded="false"><h4 class="m-0">Profile</h4></div>
                </div>
                <hr class="d-block d-lg-none mt-0">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="card card--translucent border border--shadow-10 rounded-0 u-p-3 w-100">
                            <div class="text--center mw--thumb-lg">
                                <div class="user-thumb user-thumb--edit">
                                    <div class="custom-file"><input accept="image/jpeg,image/png"
                                                                    class="d-none custom-file__input" type="file"
                                                                    id="photo" value="">
                                        <label class="custom-file__label" for="photo">
                                            <img class="thumb--md rounded-circle" src="@/assets/img/default-avatar.png">
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-gap-16">
                                <div class="">
                                    <div class="flex-grow-1 text--center">
                                        <div><span
                                                class="font-weight--bold notranslate overflow-wrap-anywhere text--black"
                                                translate="no">{{userInfo.first_name}} {{userInfo.last_name}}</span></div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1"><label for="username" class="text--sm">Username</label>
                                        <div><span class="font-weight--bold notranslate overflow-wrap-anywhere text--sm"
                                                   translate="no">{{userInfo.name}}</span></div>
                                    </div>
                                    <div>
                                        <button class="btn--icon btn--icon--primary btn--icon--sm" type="button">
                                            <svg viewBox="0 0 24 24" class="icon icon--24">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M17.45 1.922a3.043 3.043 0 0 0-1.39.641C15.631 2.906 2.667 15.92 2.504 16.17a3.159 3.159 0 0 0-.414.945c-.056.223-.067.502-.068 1.765l-.002 1.5.111.189a.862.862 0 0 0 .3.3l.189.111 1.5-.002c1.263-.001 1.542-.012 1.765-.068a2.9 2.9 0 0 0 .99-.456c.308-.215 13.196-13.063 13.569-13.526.473-.588.652-1.116.652-1.928 0-.393-.019-.611-.071-.8-.286-1.046-1.175-1.941-2.205-2.219-.289-.077-1.078-.112-1.37-.059m.933 2.025c.264.09.58.406.67.67.085.249.085.513.002.766-.06.182-.579.712-6.65 6.79-3.849 3.853-6.66 6.637-6.765 6.7-.175.104-.2.107-.913.12l-.733.013.013-.733c.013-.713.016-.738.12-.913.063-.105 2.848-2.917 6.7-6.766 7.185-7.176 6.681-6.703 7.156-6.711.111-.002.291.027.4.064m-6.764 15.109c-.241.075-.371.176-.491.38-.097.165-.108.223-.108.564 0 .343.011.398.111.569a.862.862 0 0 0 .3.3l.189.111h9.766l.195-.12c.247-.153.38-.397.408-.751.028-.344-.066-.664-.25-.847-.274-.274-.031-.262-5.256-.259-3.664.002-4.739.013-4.864.053"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1"><label for="email" class="text--sm">Email</label>
                                        <div><span class="font-weight--bold notranslate overflow-wrap-anywhere text--sm"
                                                   translate="no">{{userInfo.email}}</span></div>
                                    </div>
                                    <div>
                                        <button class="btn--icon btn--icon--primary btn--icon--sm" type="button">
                                            <svg viewBox="0 0 24 24" class="icon icon--24">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M17.45 1.922a3.043 3.043 0 0 0-1.39.641C15.631 2.906 2.667 15.92 2.504 16.17a3.159 3.159 0 0 0-.414.945c-.056.223-.067.502-.068 1.765l-.002 1.5.111.189a.862.862 0 0 0 .3.3l.189.111 1.5-.002c1.263-.001 1.542-.012 1.765-.068a2.9 2.9 0 0 0 .99-.456c.308-.215 13.196-13.063 13.569-13.526.473-.588.652-1.116.652-1.928 0-.393-.019-.611-.071-.8-.286-1.046-1.175-1.941-2.205-2.219-.289-.077-1.078-.112-1.37-.059m.933 2.025c.264.09.58.406.67.67.085.249.085.513.002.766-.06.182-.579.712-6.65 6.79-3.849 3.853-6.66 6.637-6.765 6.7-.175.104-.2.107-.913.12l-.733.013.013-.733c.013-.713.016-.738.12-.913.063-.105 2.848-2.917 6.7-6.766 7.185-7.176 6.681-6.703 7.156-6.711.111-.002.291.027.4.064m-6.764 15.109c-.241.075-.371.176-.491.38-.097.165-.108.223-.108.564 0 .343.011.398.111.569a.862.862 0 0 0 .3.3l.189.111h9.766l.195-.12c.247-.153.38-.397.408-.751.028-.344-.066-.664-.25-.847-.274-.274-.031-.262-5.256-.259-3.664.002-4.739.013-4.864.053"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="">
                                    <div class="flex-grow-1"><label for="address" class="text--sm">Address</label>
                                        <div><span class="font-weight--bold notranslate overflow-wrap-anywhere text--sm"
                                                   translate="no">{{userInfo.address}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1"><label for="phone" class="text--sm">Phone number</label>
                                        <div><span class="font-weight--bold notranslate overflow-wrap-anywhere text--sm"
                                                   translate="no">{{userInfo.mobile}}</span></div>
                                    </div>
                                    <div>
                                        <button class="btn--icon btn--icon--primary btn--icon--sm" type="button">
                                            <svg viewBox="0 0 24 24" class="icon icon--24">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M17.45 1.922a3.043 3.043 0 0 0-1.39.641C15.631 2.906 2.667 15.92 2.504 16.17a3.159 3.159 0 0 0-.414.945c-.056.223-.067.502-.068 1.765l-.002 1.5.111.189a.862.862 0 0 0 .3.3l.189.111 1.5-.002c1.263-.001 1.542-.012 1.765-.068a2.9 2.9 0 0 0 .99-.456c.308-.215 13.196-13.063 13.569-13.526.473-.588.652-1.116.652-1.928 0-.393-.019-.611-.071-.8-.286-1.046-1.175-1.941-2.205-2.219-.289-.077-1.078-.112-1.37-.059m.933 2.025c.264.09.58.406.67.67.085.249.085.513.002.766-.06.182-.579.712-6.65 6.79-3.849 3.853-6.66 6.637-6.765 6.7-.175.104-.2.107-.913.12l-.733.013.013-.733c.013-.713.016-.738.12-.913.063-.105 2.848-2.917 6.7-6.766 7.185-7.176 6.681-6.703 7.156-6.711.111-.002.291.027.4.064m-6.764 15.109c-.241.075-.371.176-.491.38-.097.165-.108.223-.108.564 0 .343.011.398.111.569a.862.862 0 0 0 .3.3l.189.111h9.766l.195-.12c.247-.153.38-.397.408-.751.028-.344-.066-.664-.25-.847-.274-.274-.031-.262-5.256-.259-3.664.002-4.739.013-4.864.053"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="">
                                    <div class="flex-grow-1"><label for="birthDate" class="text--sm">Date of
                                        birth</label>
                                        <div><span class="font-weight--bold notranslate overflow-wrap-anywhere text--sm"
                                                   translate="no">{{userInfo.birth}}</span></div>
                                    </div>
                                </div>
                                <div class="text--xs mb-2">To update your account information, please <a
                                        class="link--dark text--underline text--xs" href="mailto:support@airtm.io">contact
                                    support.</a></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-8 pl-md-0">
                        <div class="card card--translucent border border--shadow-10 rounded-0 u-p-3 w-100">
                            <div class="d-flex flex-column flex-gap-16">
                                <div><img src="@/assets/img/logo.png" alt="airners"
                                          style="height: 18px;"></div>
                                <div>
                                    <div class="text--black font-weight--bold">Turn your activity into earning power
                                    </div>
                                    <div class="text--sm"><span>By allowing Airtm to securely track your account and transaction activity, you’ll start building your Airner Identity Score—a smart way to show your earning potential. The more you earn and spend using Airtm, the higher your score—and the more earning opportunities you’ll discover.</span><br><br><span>
After each payout, you'll be asked a few quick questions to keep your profile accurate.</span><br><br><span>
By enabling this feature, you hereby attest that the information provided is wholly accurate and complete.
</span><br><span>
The provision of any false, misleading, inaccurate or incomplete information by you will be considered to be a breach of Airtm's Terms and you agree to hold Airtm harmless and to indemnify them for any third party claim arising from the provision of such information.</span>
                                    </div>
                                </div>
                                <div>
                                    <button class="btn btn--primary btn--small" type="button" data-loading="false"
                                            aria-expanded="false">Enable feature
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Vue from "vue";
    import Fetch from "@/utils/fetch";

    export default {
        name: "profile",
        data() {
            return {
                userInfo: {},
            }
        },
        mounted() {
            this.getUser();
        },
        methods: {
            getUser() {
                Fetch("/user/info").then((r) => {
                    let data = r.data;
                    this.userName = data.name ? data.name : data.mobile;
                    this.userInfo = data;
                });
            },
        },
    }
</script>

<style scoped>

</style>